import { MediaItem } from 'src/components/tag-popup/Components/MediaItem';
import { Gallery } from 'src/components/gallery/Gallery';
import { isGifUrl, isVimeoUrl, isYoutubeUrl } from 'src/utils';
import { getVideoLink } from 'src/utils/getVideoLink';
import { MediaItemStyle } from 'src/components/tag-popup/Components/types';

export const renderMediaContent = (tag, onClick, settings, inFullScreen, toggleFullScreen) => {
  const hasVideoUrl = tag?.showVideoUrl && tag?.videoUrl && tag?.videoUrl !== 'null';

  if (tag.tagGalleries?.length === 1 && !hasVideoUrl) {
    return (
      <MediaItem
        type={MediaItemStyle.Tooltip}
        url={tag.tagGalleries[0].url}
        innerStyle={{ maxWidth: '100%', maxHeight: '205px' }}
        settings={settings}
        inFullScreen={inFullScreen}
        toggleFullScreen={toggleFullScreen}
      />
    );
  }

  if (tag.tagGalleries?.length) {
    return (
      <Gallery
        items={[
          ...(hasVideoUrl ? [tag.videoUrl] : []),
          ...tag.tagGalleries
            .sort((firstItem, secondItem) => {
              if (firstItem.order < secondItem.order) {
                return -1;
              }
              if (firstItem.order > secondItem.order) {
                return 1;
              }
              return 0;
            })
            //@ts-ignore
            .map(
              (galleryItem: any) =>
                `${
                  settings.adminPanelAccess
                    ? // @ts-ignore
                      import.meta.env.VITE_APP_AWS
                    : process.env.NEXT_PUBLIC_CDN
                }${galleryItem.url}`,
            ),
        ]}
        onGalleryItemClick={onClick}
        settings={{ fullScreen: false, imageHeight: 205, thumbnailsMarginRight: -20 }}
      />
    );
  }

  if (hasVideoUrl) {
    if (isGifUrl(tag.videoUrl))
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img style={{ maxWidth: '100%' }} src={tag.videoUrl} />
        </div>
      );
    if (isYoutubeUrl(tag.videoUrl) || isVimeoUrl(tag.videoUrl))
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <iframe src={getVideoLink(tag.videoUrl)}></iframe>
        </div>
      );
  }

  return null;
};
